//current code for dashboard list auto width
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import Dropdown from "../../features/dashboardPanel";
import ForcastingDropdown from "../../features/ForcastingPanel";
import callAPI from "../../utils/callAPI";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NormalSidebar from "./normalSidebar";

const CollapsedListItemIcon = styled(ListItemIcon)(() => ({
  minWidth: "max-content",
}));

export default function Sidebar(props) {
  const location = useLocation();
  const pathName = location.pathname;

  // Hide sidebar on utilization, FWA, chatbot, workspace, widget-generator, and custom dashboards
  if (["/utilization-dashboard", "/fwa-dashboard", "/chatbot", "/workspace", "/widget-generator","/contracts-dashboard"].includes(pathName)
      || pathName.startsWith("/dashboard/")) {
    return null;
  }

  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const dropdownRef = useRef(null);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [forecastOpen, setForecastOpen] = useState(false);

  const drawerWidth = 240;
  const openedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: drawerWidth,
  });

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    minHeight: "10px",
    ...theme.mixins.toolbar,
  }));

  const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowY: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(7)} + 1px)`,
    },
  });

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }));

  const handleClose = () => {
    callAPI("GET", "logout/", "")
      .then(() => {
        localStorage.clear();
        document.cookie.split(";").forEach((cookie) => {
          document.cookie = cookie
            .replace(/^ +/, "")
            .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });
      })
      .then(() => {
        history.push("/login");
      });
  };

  const handleMouseLeave = (event) => {
    setAnchorEl(null);
  };
  const handleMenuClick = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      const target = event.currentTarget;
      setAnchorEl(target);
    }
  };

  const [isDialogueOpen, setIsDialogueOpen] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !isDialogueOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDashboardOpen(false);
        setForecastOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef, isDialogueOpen]);

  const ToggleDash = () => {
    setDashboardOpen(!dashboardOpen);
  };
  const ToggleForecast = () => {
    setForecastOpen(!forecastOpen);
  };

  return (
    <div className="flex mr-0">
      <div>
        <Drawer
          variant="permanent"
          open={props.open}
          onClose={props.handleDrawerClose}
          PaperProps={{
            sx: {
              backgroundColor: "f7f7f7",
              boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
            },
          }}
        >
          <NormalSidebar
            ToggleForecast={ToggleForecast}
            ToggleDash={ToggleDash}
            setForecastOpen={setForecastOpen}
            setDashboardOpen={setDashboardOpen}
            handleMenuClick={handleMenuClick}
            anchorEl={anchorEl}
            handleClose={handleClose}
            pathName={pathName}
            CollapsedListItemIcon={CollapsedListItemIcon}
            handleMouseLeave={handleMouseLeave}
          />
        </Drawer>
      </div>

      {dashboardOpen && (["/widget-generator", "/workspace"].includes(pathName)) && (
        <div
          ref={dropdownRef}
          className="bg-white square w-64 z-50 fixed -mt-10 mr-4 ml-8"
          style={{
            height: "150%",
            boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
            width: "25rem"
          }}
        >
          <Dropdown
            setIsDialogueOpen={setIsDialogueOpen}
            pathName={pathName}
            ToggleDash={ToggleDash}
          />
        </div>
      )}

      {forecastOpen && (
        <div
          ref={dropdownRef}
          className="bg-white square w-64 z-50 fixed -mt-10 mr-4 ml-8"
          style={{
            height: "150%",
            boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <ForcastingDropdown
            pathName={pathName}
            ToggleForecast={ToggleForecast}
          />
        </div>
      )}
    </div>
  );
}